import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

export default function TriagemFab() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 500);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Link
      to="/triagem"
      data-testid="triagem-fab"
      aria-label="Fazer triagem orientativa"
      className={`fixed bottom-24 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-white text-ga-ink border-2 border-ga-emerald shadow-xl pl-3 pr-4 py-2.5 text-sm font-bold transition-all duration-300 hover:bg-ga-emerald hover:text-white hover:scale-[1.03] ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="w-7 h-7 rounded-full bg-ga-emerald/10 text-ga-emerald flex items-center justify-center transition-colors group-hover:bg-white/15">
        <Shield className="w-3.5 h-3.5" />
      </span>
      <span className="hidden sm:inline">Triagem orientativa</span>
      <span className="sm:hidden">Triagem</span>
    </Link>
  );
}
